<template>
<div class="chapter">
<div class="inner_page">
<div class="Title_Page">
<p class="imageb"><a id="page_20"><img alt="images" src="images/img_p25-1.jpg"/></a></p><a id="page_20">
</a><h2 class="chaptitle2"><a id="page_20"></a><a href="#/006_Contents#ch6" id="rch6"><b>Always Spit After a Fisherman</b></a></h2>
<p class="sub2"><b>Want people from other countries to think you’re polite? Of course you do. So here are a few BRI tips about what’s considered good manners around the world.</b></p>
<p class="image"><img alt="images" src="images/img_p25-2.jpg"/></p>
<p class="image"><img alt="images" src="images/img_p25-3.jpg"/></p>
<p class="noindenta"><a id="page_21"><b><span class="font2"><span class="lyell">IN JAPAN:</span></span> Wear a surgical mask in public if you have a cold.</b></a></p><a id="page_21">
<p class="noindenta"><b><span class="font2"><span class="lyell">IN SWITZERLAND:</span></span> Buy wine for your table if you drop your bread in the fondue.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN ITALY:</span></span> Don’t allow a woman to pour wine.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN SAMOA:</span></span> Spill a few drops of kava, the national beverage, before drinking.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN BELGIUM AND LUXEMBOURG:</span></span> Avoid sending a gift of chrysanthemums. They are a reminder of death.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN SWEDEN:</span></span> Wait until you’re outside your guest’s house before putting your coat on.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN JORDAN:</span></span> Leave small portions of food on your plate. Also, refuse seconds at least twice before accepting.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN GREECE:</span></span> Cheerfully participate in folk dancing if invited.</b></p>
<p class="image"><img alt="images" src="images/img_p26.jpg"/></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN PORTUGAL:</span></span> Signal you enjoyed a meal by kissing your index finger and then pinching your earlobe.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN CHINA:</span></span> Decline a gift a few times before accepting. Use both hands to give or receive one.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN KOREA:</span></span> Allow others to pass between you and the person you are conversing with. Don’t make anyone walk behind you.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN IRAN:</span></span> Shake hands with children. (It shows respect for their parents.)</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN SPAIN:</span></span> Say “buen provecho” to anyone beginning a meal.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN FINLAND:</span></span> If you pass the salt at the dinner table, don’t put it in anyone’s hand—put the salt shaker down and let them pick it up.</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN FIJI:</span></span> Fold your arms behind you when conversing</b></p>
<p class="noindenta"><b><span class="font2"><span class="lyell">IN NORWAY:</span></span> When a fisherman walks by, spit after him. It’s a way of wishing him good luck.</b></p>
<p class="centers"><b>MARK WAHLBERG HAS THREE NIPPLES.</b></p>
</a></div><a id="page_21">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 013_Chapter6.vue?60493bab